import type { AxiosInstance } from 'axios'
import type { IFactoryFunctionRequest, ISector } from '@bc-library/interface'
import { EMethod } from '@bc-library/interface'
import { API_MAIN_VERSION, BASE_URL } from '@/config/constantes'
import useAxios from '@/services/api/useAxios'

const resource = 'sectors'

const getFilter = (axios: IFactoryFunctionRequest<Array<Pick<ISector, '_id' | 'display'>>, undefined>) => () => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/firm/filter`,
  })
}

const getAll = (axios: IFactoryFunctionRequest<Array<ISector>, undefined>) => (firmId: string) => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/firm/${firmId}`,
  })
}

const createOne = (axios: IFactoryFunctionRequest<ISector, Partial<ISector>>) => (data: Partial<ISector>) => {
  return axios({
    method: EMethod.post,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}`,
    data,
  })
}

const updateOne = (axios: IFactoryFunctionRequest<ISector, Partial<ISector>>) => (sectorId: string, data: Partial<ISector>) => {
  return axios({
    method: EMethod.put,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/${sectorId}`,
    data,
  })
}

const filter = (axios: IFactoryFunctionRequest<any, any>) => (query) => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/filter`,
    query,
  })
}

const createManagement = (axios: IFactoryFunctionRequest<ISector, Partial<ISector>>) => (data: Partial<ISector>) => {
  return axios({
    method: EMethod.post,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/management/create`,
    data,
  })
}


export default (axios: AxiosInstance) => ({
  getFilter: getFilter(useAxios(axios)),
  getAll: getAll(useAxios(axios)),
  createOne: createOne(useAxios(axios)),
  createManagement: createManagement(useAxios(axios)),
  updateOne: updateOne(useAxios(axios)),
  filter: filter(useAxios(axios)),
})
